module.exports = require("@swa-ui/itinerary/src/FlightDuration/FlightDuration.module.scss");